import { render, staticRenderFns } from "./InspectQuery.vue?vue&type=template&id=489e967b"
import script from "./InspectQuery.vue?vue&type=script&lang=js"
export * from "./InspectQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports